import React from 'react';
import { Icon, Oval, Matchcount } from './components';

export default ({
    node,
    vsum,
    left,
    top,
    match_count,
    showMatchBubbleFor,
    stopStageClickPropagation,
    hideMatchBubbleFor,
    zoomOutFromMobileFlipCard,
    magnifyImage,
    cursorBecomesMove,
    cursorBecomesPointer,
    userTouchedNode,
    skipZoomInOutSteppingNow,
    buildRefObj,
    callRefObj,
  }) => {

  const props = {
    node,
    left,
    top,
    match_count,
    magnifyImage,
    showMatchBubbleFor,
    stopStageClickPropagation,
    hideMatchBubbleFor,
    zoomOutFromMobileFlipCard,
    cursorBecomesMove,
    cursorBecomesPointer,
    userTouchedNode,
    skipZoomInOutSteppingNow,
    vsum,
    buildRefObj,
    callRefObj,
  };

  return [
      <Icon key={Math.random()} {...props} />,
      <Oval key={Math.random()} {...props} />,
      <Matchcount key={Math.random()} {...props} />,
    ]
};

